import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderClaimForm, setOrderClaimForm } from 'domains/order/Order.store';
import { getTextWithMandatoryFlag, isHidden, isMessageMandatory } from 'pages/MyOrdersPage/OrderClaims/claimForm.utils';
import { makeKey, RULES_DATA } from 'pages/MyOrdersPage/OrderClaims/claimFormRulesData';
import { Text, TextArea } from 'UI';

const MessageSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const claimForm = useSelector(getOrderClaimForm);
  const rulesData =
    RULES_DATA[makeKey({ formType: claimForm.formType, reason: claimForm.reason, option: claimForm.option })];

  const allSectionFields = [rulesData?.message];

  const isMessageSectionHidden = allSectionFields.every((field) => isHidden(field));

  if (isMessageSectionHidden) {
    return null;
  }

  return (
    <>
      <Text type="heading3" disableGutter noWrap>
        {getTextWithMandatoryFlag(t('assistance.contact_us.message', 'Message'), isMessageMandatory(claimForm))}
      </Text>
      {!isHidden(rulesData?.message) && (
        <TextArea
          initialValue={claimForm.message}
          onChangeDebounced={(message: string) => dispatch(setOrderClaimForm({ ...claimForm, message }))}
          placeholder={t('common.enter_message_here', 'Enter your message here..')}
          showCount
          maxLength={300}
        />
      )}
    </>
  );
};

export default MessageSection;
